const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Articles Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Articles', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  var fields = 'title,createdAt,explore_hide,category,image,banner_image,linked_category';
  var detailsFields = 'user,title,author,link,summary,content,required,category,image,image_names,explore_hide,banner_image,duration,tags,mardown,markdownContent,linked_category';
  return $resource(appConfiguration.apiUrl + '/learn/v3/articles/:subresource/:action', null, {
    get: {params: {fields: detailsFields, subresource: ''}, method: 'GET', isArray: false},
    find: {params: {fields: fields, subresource: ''}, method: 'GET', isArray: true},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    duplicate: {params: {subresource: '', action: 'duplicate'}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
}]);
